import { ArrowRightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import Container from "../General/Container/Container";
import MinifiedCreation from "./MinifiedCreation";
import MinifiedResult from "./MinifiedResult";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MinifiedContent = () => {
    const navigate = useNavigate();
    const { mode } = useSelector((state) => state.minified);

    return <Container className="minified-content fullscreen">
        {mode === "result"
            ? <MinifiedResult />
            : <>
                <MinifiedCreation />
                <Button
                    className="minified-content-advance"
                    type="link"
                    onClick={() => {
                        navigate("/advanced")
                    }}
                >
                    Advanced Analysis <ArrowRightOutlined />
                </Button>
            </>}
    </Container>
}

export default MinifiedContent